import React, {Component} from 'react';
import {connect} from 'react-redux'
import AdvancedDisbursementsList from "../../components/AdvancedDisbursements/advancedDisbursementsList";
import _ from 'lodash';
import {
    advanceDisbursementsListPageShift,
    changeAdvancedDisbursementsListSettings, clearAdvanceDisbursementsFilters
} from "../../actions/advancedDisbursementsList";
import {
    changeAdvanceDisbursementsStoreSettings,
    getAdvanceDisbursementsDueForPayment,
    getAdvanceDisbursementsStatementMessages,
    getAdvanceDisbursementsStatuses,
    getAdvanceDisbursementsRejectionReasons,
    getAllAdvancedDisbursements,
    getAllAdvancedDisbursementsSuggestions,
    receiveAllAdvancedDisbursements
} from "../../actions/advancedDisbursements";
import {changeActiveTab} from "../../actions/applicationPolicy";
import { push } from 'connected-react-router'
import {getCaseTypes} from "../../actions/caseTypes";
import {requestLawsysFirmsWithAgents} from "../../actions/lawsysFirms";
import {isAragUser, isSolicitorUser} from "../../helpers/functions";

import {
    ADVANCE_DISBURSEMENTS_PROCESSING_FILTER_STATUS_MACHINE_NAME, CURRENCY
} from "../../helpers/variables";
import generatePolicyADStatement from "../../helpers/generatePolicyADStatement";
import {getADStatementMessages} from "../../helpers/advanceDisbursementsUtils";
import {requestGetSolicitorDetails} from "../../actions/manageSolicitorAccount";

class AdvancedDisbursementsListHOC extends Component {
    constructor(props){
        super(props);
        let askServer;
    }

    componentDidMount(){
        let parameters = this.getRequestParameters(this.props);
        this.props.getAllAdvancedDisbursements(parameters);
        this.props.getAdvanceDisbursementsStatuses();
        this.props.getAdvanceDisbursementsRejectionReasons();
        this.props.requestGetCaseTypes();
        if(isAragUser(this.props.loggedInUserRoles)){
            this.props.requestLawsysFirmsWithAgents();
        }

        if(isSolicitorUser(this.props.loggedInUserRoles)){
            this.props.getSolicitorDetails(this.props.loggedInUserId)
        }


        this.props.getAdvanceDisbursementsStatementMessages();
    }

    componentWillReceiveProps(nextProps){
        clearTimeout(this.askServer);
        if(
            (
                this.props.advancedDisbursementsList.page !== nextProps.advancedDisbursementsList.page
                || this.props.advancedDisbursementsList.statusFilter !== nextProps.advancedDisbursementsList.statusFilter
                || this.props.advancedDisbursementsList.textFilter !== nextProps.advancedDisbursementsList.textFilter
                || this.props.advancedDisbursementsList.viewAmount !== nextProps.advancedDisbursementsList.viewAmount
                || this.props.advancedDisbursementsList.wasFilterButtonPressed && !nextProps.advancedDisbursementsList.wasFilterButtonPressed
            )
        ){
            let parameters = this.getRequestParameters(nextProps);
            if(this.props.advancedDisbursementsList.textFilter!==nextProps.advancedDisbursementsList.textFilter && nextProps.advancedDisbursementsList.textFilter!==''){
                parameters.offset = 0;
                parameters.limit = 5;
                this.askServer = setTimeout(()=>{this.props.getAllAdvancedDisbursementsSuggestions(parameters)},150);
            }else {
                this.props.getAllAdvancedDisbursements(parameters);
            }
        }

        if(
            this.props.fetchingADDueForPayment && !nextProps.fetchingADDueForPayment
            && !nextProps.fetchAdsDueForPaymentErrorMessage
        ) {
            const pdfMake = require('pdfmake/build/pdfmake.js');
            const pdfFonts = require('pdfmake/build/vfs_fonts.js');
            pdfMake.vfs = pdfFonts.pdfMake.vfs;

            //calculate the targeted lawsys that the statement is for
            let lawsys = {lawsysName: "", addressLine1: "", postCode: ""};
            if(isSolicitorUser(this.props.loggedInUserRoles)){
                lawsys = {
                    lawsysName: this.props.solicitorDetails.lawsysName,
                    addressLine1: this.props.solicitorDetails.addressLine1,
                    postCode: this.props.solicitorDetails.postCode
                };
            } else if(
                isAragUser(this.props.loggedInUserRoles)
                && nextProps.advancedDisbursementsList.selectedFirms.length === 1
            ) {
                const selectedFirmId = nextProps.advancedDisbursementsList.selectedFirms[0].value;
                const lawsysFirm = nextProps.lawsysFirms.find(e => e.id === selectedFirmId);
                if(lawsysFirm){
                    lawsys = {lawsysName: lawsysFirm.name, addressLine1: lawsysFirm.address, postCode: lawsysFirm.postcode}
                }
            }


            const data = {
                advancedDisbursements: nextProps.advancedDisbursementsDueForPayment,
                lawsysFirm: lawsys,
                statementMessages: getADStatementMessages(this.props.statementMessages)
            };
            const generatedStatement =  pdfMake.createPdf(generatePolicyADStatement(data));
            const fileName = `Advance_Disbursements_Statement.pdf`;
            generatedStatement.download(fileName)
        }
    }

    getRequestParameters= (props) => {
        const currentPage = parseInt(props.advancedDisbursementsList.page);
        const calcOffset = props.advancedDisbursementsList.viewAmount*(currentPage -1);
        let paymentInstructionId = null;
        let selectedAdStatus = [...props.advancedDisbursementsList.selectedStatuses];
        if (
            selectedAdStatus.find(e => e.value ===  ADVANCE_DISBURSEMENTS_PROCESSING_FILTER_STATUS_MACHINE_NAME)
        ){
            const approvedStatus = props.advanceDisbursementsStatuses.find(e => e.machineName === 'approved');

            if(
                approvedStatus
                && selectedAdStatus.find(e => e.value.toString() ===  approvedStatus.id.toString())
            ) {
                paymentInstructionId = 0;
            } else {
                paymentInstructionId = -1;
            }

            if(approvedStatus){
                selectedAdStatus = selectedAdStatus
                    .map(e => e.value === ADVANCE_DISBURSEMENTS_PROCESSING_FILTER_STATUS_MACHINE_NAME ?
                        {...e, value: approvedStatus.id}
                        :
                        e
                    )
            }
        }

        return {
            limit: parseInt(props.advancedDisbursementsList.viewAmount),
            offset: calcOffset>0? calcOffset:0,
            search: props.advancedDisbursementsList.textFilter === '' ? null : props.advancedDisbursementsList.textFilter,
            minAmount: props.advancedDisbursementsList.amountFrom? props.advancedDisbursementsList.amountFrom: null,
            maxAmount: props.advancedDisbursementsList.amountTo? props.advancedDisbursementsList.amountTo: null ,
            selectedCaseTypes: props.advancedDisbursementsList.selectedCaseTypes,
            selectedSubCaseTypes: props.advancedDisbursementsList.selectedSubCaseTypes,
            selectedFirms: props.advancedDisbursementsList.selectedFirms,
            selectedStatuses: selectedAdStatus,
            paymentInstructionId: paymentInstructionId
        };
    };

    _getAdStatusName = (statusId) => {
        let status ;
        status = _.find(this.props.advanceDisbursementsStatuses, s => {
            return s.id === parseInt(statusId);
        });
        if(status){
            return status.name
        }
        else {
            return '';
        }
    };

    _getFilterByStatusOptions = () => {
        const options =  this.props.advanceDisbursementsStatuses.map(i => ({value: i.id, label: i.name}));
        options.push({value: ADVANCE_DISBURSEMENTS_PROCESSING_FILTER_STATUS_MACHINE_NAME, label: 'Processing'});
        return options;
    };

    _changeFilterByStatus = (evt) => {
        this.props.changeStoreSettings({
            key: evt.target.name,
            value: evt.target.value
        });
    };

    _changeTableViewOptions = (evt) => {
        this.props.changeStoreSettings({
            key: "viewAmount",
            value: evt.target.value
        });
    };


    //function that handles the row selection for the advanced disbursements table
    _handleAdSelect = (policyId) => {
        this.props.push('/application-and-policies/application-policy/' + policyId);
        this.props.changeActiveTab('advancedDisbursements')
    };

    //shifts ad table page
    _shiftAdTablePage = (direction) => {
        this.props.pageShift(direction)
    };

    //changes ad page
    _changeAdvancedDisbursementsPage = (name, value) => {
        this.props.changeStoreSettings({
            key:name,
            value: value
        });
    };

    //=== auto suggest handlers ===//
    // Teach Autosuggest how to calculate suggestions for any given input value.
    _getSuggestions = value => {
        return this.props.advancedDisbursementsList.suggestions

    };

    _getSuggestionValue = suggestion => suggestion !== undefined ?suggestion.applicationId: null;

    _renderSuggestion = suggestion => (
        <div>
            {
                (suggestion.aragReference? suggestion.aragReference: '') +
                (suggestion.amount? (` | ${CURRENCY} ` + suggestion.amount): '')
            }
        </div>
    );

    _onChange = (event, {newValue}) => {
        if (typeof newValue !== 'undefined') {
            if (newValue === '') {
            }
            this.props.changeStoreSettings({
                key: 'textFilter',
                value: newValue? newValue.toString(): ''
            });
        }
    };

    _onSuggestionsFetchRequested = ({value, reason}) => {
        this.props.changeStoreSettings({
            key: 'suggestions',
            value: this._getSuggestions(value)
        });
    };

    _onSuggestionsClearRequested = () => {
        if (this.props.advancedDisbursementsList.textFilter === '') {
            this.props.changeStoreSettings({
                key: 'suggestions',
                value: []
            });
        }
    };

    _onAdSuggestionSelected = (event, {suggestion, suggestionValue, suggestionIndex, sectionIndex, method}) => {
        if (method === 'enter' || method === 'click' ){
            let newValue = '';
            if(suggestion.applicationId !=='' && suggestion.applicationId!==0){
                newValue = suggestion.aragReference;
            }
            let payload = {
                body: {
                    data: [suggestion],
                    limit:0,
                    offset:0,
                    totalAppliedRecords: this.props.aDTotalAppliedRecords,
                    totalAppliedValue: this.props.aDTotalAppliedValue,
                    totalApprovedRecords: this.props.aDTotalApprovedRecords,
                    totalApprovedValue: this.props.aDTotalApprovedValue,
                    totalRecords: this.props.aDTotalRecords,
                    totalValue: this.props.aDTotalValue
                }
            };
            this.props.receiveAllAdvancedDisbursements(payload);
            this.props.changeStoreSettings({
                key: 'textFilter',
                value: newValue? newValue.toString(): ''
            });
            this.props.changeStoreSettings({
                key: 'textFilter',
                value: newValue? newValue.toString(): ''
            });
            this.props.changeAdvanceDisbursementsStoreSettings({
               key: 'advancedDisbursements',
               value: [suggestion]
            });
        }
    };

    _handleAutosuggestButton = (suggestion) => {
        let parameters = this.getRequestParameters(this.props);
        this.props.getAllAdvancedDisbursements(parameters);
    };

    _handleAutosuggestValue = (suggestion) => {
        let parameters = this.getRequestParameters(this.props);
        this.props.getAllAdvancedDisbursements(parameters);
    };
    //===========================//

    _handleInputChange = (evt) => {
        this.props.changeStoreSettings({
            key: evt.target.name,
            value: evt.target.value
        })
    };

    _filterByRange = () => {
        this.props.changeStoreSettings({key: 'wasFilterButtonPressed', value: true});
        let parameters = this.getRequestParameters(this.props);
        this.props.getAllAdvancedDisbursements(parameters);
    };

    clearFilters = () => {
        this.props.clearAdvanceDisbursementsFilters();
    };

    getSubCaseTypesOptions = () => {
        return this.props.caseTypes
            .filter(ct => !!this.props.advancedDisbursementsList.selectedCaseTypes.find(sel => sel.value === ct.id))
            .reduce((acc, current) =>  [
                ...acc,
                ...current.subCaseTypes.map(
                    type => ({value: type.id, label: type.name, machineName: type.machineName})
                )
            ], [])
    };

    onPrintStatement = () => {
        const paidAdStatus = this.props.advanceDisbursementsStatuses.find(status => status.machineName === "paid");
        let lawsysId = "";
        if(!paidAdStatus){
            return null;
        }

        if(
            isAragUser(this.props.loggedInUserRoles)
            && this.props.advancedDisbursementsList.selectedFirms.length === 1
        ){
            lawsysId = this.props.advancedDisbursementsList.selectedFirms[0].value
        } else if (
            isSolicitorUser(this.props.loggedInUserRoles)
        ) {
            lawsysId = this.props.solicitorDetails.lawsysId;
        } else {
            return ;
        }

        this.props.getAdvanceDisbursementsDueForPayment({
            paidAdStatusId: paidAdStatus.id,
            lawsysId
        })
    };

    render() {
        let value = this.props.advancedDisbursementsList.textFilter;
        const autoSuggesetInputProps = {
            placeholder: '',
            value,
            onChange: this._onChange
        };
        return (
            <AdvancedDisbursementsList
                fetchingADDueForPayment={this.props.fetchingADDueForPayment}
                onPrintStatement={this.onPrintStatement}
                subCaseTypes={this.getSubCaseTypesOptions()}
                clearFilters={this.clearFilters}
                changeStoreSettings={this.props.changeStoreSettings}
                _filterByRange={this._filterByRange}
                _handleInputChange={this._handleInputChange}
                _handleAdSelect={this._handleAdSelect}
                _getSuggestions={this._getSuggestions}
                _getSuggestionValue={this._getSuggestionValue}
                _renderSuggestion={this._renderSuggestion}
                _onSuggestionsFetchRequested={this._onSuggestionsFetchRequested}
                _onSuggestionsClearRequested={this._onSuggestionsClearRequested}
                _onAdSuggestionSelected={this._onAdSuggestionSelected}
                _handleAutosuggestButton={this._handleAutosuggestButton}
                _handleAutosuggestValue={this._handleAutosuggestValue}
                autoSuggesetInputProps={autoSuggesetInputProps}
                fetchingAdvancedDisbursements={this.props.fetchingAdvancedDisbursements}
                _changeAdvancedDisbursementsPage={this._changeAdvancedDisbursementsPage}
                _shiftAdTablePage={this._shiftAdTablePage}
                _changeTableViewOptions={this._changeTableViewOptions}
                advancedDisbursementsList={this.props.advancedDisbursementsList}
                _changeFilterByStatus={this._changeFilterByStatus}
                filterByStatusOptions={this._getFilterByStatusOptions()}
                totalNumberOfApplied={this.props.aDTotalAppliedRecords}
                totalNumberOfAdvancedDisbursements={this.props.aDTotalRecords}
                totalNumberOfApproved={this.props.aDTotalApprovedRecords}
                totalValueOfAdvancedDisbursements={this.props.aDTotalValue}
                totalValueOfApplied={this.props.aDTotalAppliedValue}
                totalValueOfApproved={this.props.aDTotalApprovedValue}
                advancedDisbursements={this.props.advancedDisbursements}
                caseTypes={this.props.caseTypes}
                fetchingCaseTypes={this.props.fetchingCaseTypes}
                lawsysFirms={this.props.lawsysFirms}
                fetchingLawsysFirms={this.props.fetchingLawsysFirms}
                loggedInUserRoles={this.props.loggedInUserRoles}
                totalSettledRecords={this.props.totalSettledRecords}
                totalSettledValue={this.props.totalSettledValue}
                totalRejectedRecords={this.props.totalRejectedRecords}
                totalRejectedValue={this.props.totalRejectedValue}
                totalProcessingRecords={this.props.totalProcessingRecords}
                totalProcessingValue={this.props.totalProcessingValue}
                totalPaidRecords={this.props.totalPaidRecords}
                totalPaidValue={this.props.totalPaidValue}
                totalPartSettledRecords= {this.props.totalPartSettledRecords}
                totalPartSettledValue= {this.props.totalPartSettledValue}
            />
        )
    }
}

const mapStateToProps = (state) => {
    return {
        totalRejectedRecords: state.advancedDisbursements.totalRejectedRecords,
        totalRejectedValue: state.advancedDisbursements.totalRejectedValue,
        totalSettledRecords: state.advancedDisbursements.totalSettledRecords,
        totalSettledValue: state.advancedDisbursements.totalSettledValue,
        totalPartSettledRecords: state.advancedDisbursements.totalPartSettledRecords,
        totalPartSettledValue: state.advancedDisbursements.totalPartSettledValue,
        advancedDisbursementsList: state.advancedDisbursementsList,
        advancedDisbursements: state.advancedDisbursements.advancedDisbursements,
        advanceDisbursementsStatuses: state.advancedDisbursements.advanceDisbursementsStatuses,
        fetchingAdvancedDisbursements: state.advancedDisbursements.fetching,
        advanceDisbursementsRejectionReasons: state.advancedDisbursements.advanceDisbursementsRejectionReasons,
        aDTotalAppliedRecords: state.advancedDisbursements.totalAppliedRecords,
        aDTotalAppliedValue: state.advancedDisbursements.totalAppliedValue,
        aDTotalApprovedRecords: state.advancedDisbursements.totalApprovedRecords,
        aDTotalApprovedValue: state.advancedDisbursements.totalApprovedValue,
        aDTotalRecords: state.advancedDisbursements.totalRecords,
        aDTotalValue: state.advancedDisbursements.totalValue,
        totalProcessingRecords: state.advancedDisbursements.totalProcessingRecords,
        totalProcessingValue: state.advancedDisbursements.totalProcessingValue,
        totalPaidRecords: state.advancedDisbursements.totalPaidRecords,
        totalPaidValue: state.advancedDisbursements.totalPaidValue,
        caseTypes: state.caseTypes.cases,
        fetchingCaseTypes: state.caseTypes.fetching,
        lawsysFirms: state.lawsysFirms.lawsysFirms,
        fetchingLawsysFirms: state.lawsysFirms.fetching,
        loggedInUserRoles: state.user.loggedInUser.roles,
        loggedInUserId: state.user.loggedInUser.id,
        fetchingADDueForPayment: state.advancedDisbursements.fetchingADDueForPayment,
        fetchAdsDueForPaymentErrorMessage: state.advancedDisbursements.fetchAdsDueForPaymentErrorMessage,
        advancedDisbursementsDueForPayment: state.advancedDisbursements.advancedDisbursementsDueForPayment,
        statementMessages: state.advancedDisbursements.statementMessages,
        solicitorDetails: state.manageSolicitorAccount.solicitorData,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeStoreSettings: (payload) => {
            dispatch(changeAdvancedDisbursementsListSettings(payload))
        },
        getAllAdvancedDisbursements: (payload) => {
            dispatch(getAllAdvancedDisbursements(payload))
        },
        pageShift: (payload) => {
            dispatch(advanceDisbursementsListPageShift(payload))
        },
        receiveAllAdvancedDisbursements: (payload) => {
            dispatch(receiveAllAdvancedDisbursements(payload))
        },
        getAllAdvancedDisbursementsSuggestions: (payload) => {
            dispatch(getAllAdvancedDisbursementsSuggestions(payload))
        },
        changeAdvanceDisbursementsStoreSettings: (payload) => {
            dispatch(changeAdvanceDisbursementsStoreSettings(payload))
        },
        changeActiveTab: (tab) => {
            dispatch(changeActiveTab(tab))
        },
        push: (url) => {
            dispatch(push(url))
        },
        getAdvanceDisbursementsStatuses: () => {
            dispatch(getAdvanceDisbursementsStatuses())
        },
        getAdvanceDisbursementsRejectionReasons: () => {
            dispatch(getAdvanceDisbursementsRejectionReasons())
        },
        requestGetCaseTypes: () => {
            dispatch(getCaseTypes())
        },
        requestLawsysFirmsWithAgents: (payload) => {
            dispatch(requestLawsysFirmsWithAgents(payload))
        },
        clearAdvanceDisbursementsFilters: (payload) => {
            dispatch(clearAdvanceDisbursementsFilters(payload))
        },
        getAdvanceDisbursementsDueForPayment: (payload) => {
            dispatch(getAdvanceDisbursementsDueForPayment(payload))
        },
        getAdvanceDisbursementsStatementMessages: (payload) => {
            dispatch(getAdvanceDisbursementsStatementMessages(payload))
        },
        getSolicitorDetails: (id) => {
            dispatch(requestGetSolicitorDetails(id))
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(AdvancedDisbursementsListHOC);
